/*
 * Depow Help Center — KB search
 * 用 Shopify 官方 predictive search API，前端过滤只保留 KB blog 的 article。
 * 不依赖任何第三方库。
 */
(function () {
  var KB_BLOG_HANDLE = 'help-center';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function renderResults(container, articles) {
    if (!articles.length) {
      container.innerHTML = '<div class="kb-search__empty">No results</div>';
      container.classList.add('is-open');
      return;
    }
    var html = articles.map(function (a) {
      var crumb = a.crumb || 'Help Center';
      return '<a class="kb-search__result" href="' + a.url + '">' +
             '<span class="kb-search__result__crumb">' + crumb + '</span>' +
             '<span>' + a.title + '</span>' +
             '</a>';
    }).join('');
    container.innerHTML = html;
    container.classList.add('is-open');
  }

  function initSearch(root) {
    var input = root.querySelector('.kb-search__input');
    var results = root.querySelector('.kb-search__results');
    if (!input || !results) return;

    var doSearch = debounce(function () {
      var q = input.value.trim();
      if (!q) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=article&resources[limit]=10' +
                '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
          // 只保留 KB blog 下的文章
          var filtered = articles.filter(function (a) {
            return a.url && a.url.indexOf('/blogs/' + KB_BLOG_HANDLE + '/') !== -1;
          });
          renderResults(results, filtered);
        })
        .catch(function () {
          results.innerHTML = '<div class="kb-search__empty">Search unavailable</div>';
          results.classList.add('is-open');
        });
    }, 200);

    input.addEventListener('input', doSearch);
    input.addEventListener('focus', function () {
      if (input.value.trim()) doSearch();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) results.classList.remove('is-open');
    });

    // Enter key → 跳到搜索结果页（同样带 blog filter，服务端搜索也会有前缀）
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (!q) return;
        window.location.href = '/search?type=article&q=' + encodeURIComponent(q);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kb-search]').forEach(initSearch);
  });
})();
